<template>
<!-- 退客审核 -->
<section class="viewContainer">
  <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
    <el-tab-pane label="审核管理" name="first"/>
    <el-tab-pane label="黑名单管理" name="second"/>
  </el-tabs>

  <!-- 审核管理 -->
  <div v-show="activeName=='first'">
    <!-- 顶部搜索框 -->
    <div class="main_container">
      <div class="fuji" @click="show3 = !show3">
        <div class="goodslist1">
          <span style="margin-left:20px;margin-top:5px">搜索/查询</span>
          <span class="divReset" @click.stop="fnReset"><img src="../../assets/img/Reset.png" alt /></span>
        </div>
        <div style="position: absolute;right:0;top:-10px" class="sanjiao"/>
      </div>
      <el-collapse-transition>
      <div v-show="show3">
        <el-form class="findform">
          <el-form-item label="商家名称：" style="display:flex;width:25%">
            <el-input  v-model="orderNumber" placeholder="请输入商家店铺名称或个人商家手机号码" maxlength="30" style="width:90%;"/>
          </el-form-item>
          <el-form-item label="申请时间：" style="display:flex;width:25%">
            <el-date-picker type="daterange" v-model="orderTime" @change="changetime" style="width:90%;"
            value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"/>
          </el-form-item>
          <el-form-item label="审核状态：" style="display:flex;width:25%" class="select">
            <el-select v-model="shztid" placeholder="请选择" style="width:90%;">
              <el-option v-for="(item,index) in shztArr" :key="index" :value="item.id" :label="item.name"/>
            </el-select>
          </el-form-item>
          <el-form-item> <el-button type="danger" @click="onSubmit">查询</el-button> </el-form-item>
        </el-form>
      </div>
      </el-collapse-transition>
    </div>
    <!-- 审核管理列表 -->
    <div class="main_container">
      <section class="model_section">
        <p class="model_top_title">审核管理</p>
      </section>
      <div class="table_container">
        <el-table :data="chargebackList" stripe border>
          <el-table-column prop="num" label="序号" width="60" align="center">
            <template scope="scope">{{scope.$index + 1}}</template>
          </el-table-column>
          <el-table-column label="申请商家名称" align="center">
            <template scope="scope">
              <span class="spanList" :title="scope.row.businessname">{{scope.row.businessname}}</span>
            </template>
          </el-table-column>
          <el-table-column label="客户姓名" align="center" width="100">
            <template scope="scope">{{scope.row.name}}</template>
          </el-table-column>
          <el-table-column label="客户电话" align="center" width="100">
            <template scope="scope">{{scope.row.phone}}</template>
          </el-table-column>
          <el-table-column label="客户需求" align="center" width="100">
            <template scope="scope">{{scope.row.cluetypename}}</template>
          </el-table-column>
          <el-table-column label="需求描述" align="center" width="180">
            <template scope="scope">
              <span class="spanList" :title="scope.row.remark" v-if="scope.row.remark">{{ scope.row.remark }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column label="购买周期（天）" align="center" width="130">
            <template scope="scope">{{scope.row.cyclename}}</template>
          </el-table-column>
          <el-table-column label="申请退款时间" align="center" width="160">
            <template scope="scope">{{scope.row.applytime}}</template>
          </el-table-column>
          <el-table-column label="退款理由" align="center">
            <template scope="scope">
              <span class="spanList" :title="scope.row.reson">{{scope.row.reson}}</span>
            </template>
          </el-table-column>
          <el-table-column label="状态" align="center">
            <template scope="scope">{{scope.row.statusname}}</template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="150" align="center">
            <template slot-scope="scope">
              <span class="handle" @click="shenhe(scope.row)" v-show="scope.row.status == 10">
                <i class="el-icon-edit-outline"></i>审核
              </span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination layout="prev, pager, next" @current-change="currentchangeOne"
        :page-size="10" :total="totalOne" :current-page="pageIndexOne" style="margin:10px 0;float:right;"/>
      </div>
    </div>
  </div>

  <!-- 黑名单管理 -->
  <div v-show="activeName=='second'">
    <!-- 顶部搜索框 -->
    <div class="main_container">
      <div class="fuji" @click="show3 = !show3">
        <div class="goodslist1">
          <span style="margin-left:20px;margin-top:5px">搜索/查询</span>
          <span class="divReset" @click.stop="fnReset"><img src="../../assets/img/Reset.png" alt /></span>
        </div>
        <div style="position: absolute;right:0;top:-10px" class="sanjiao"/>
      </div>
      <el-collapse-transition>
      <div v-show="show3">
        <el-form class="findform">
          <el-form-item label="商家名称：" style="display:flex;width:30%">
            <el-input  v-model="qiyeName" placeholder="请输入商家店铺名称或个人商家手机号码" maxlength="30" style="width:90%;"/>
          </el-form-item>
          <el-form-item> <el-button type="danger" @click="onSubmit" style="margin-right: 20px">查询</el-button> </el-form-item>
          <el-form-item> <el-button type="primary" @click="handleyjz">预警值设置</el-button> </el-form-item>
        </el-form>
      </div>
      </el-collapse-transition>
    </div>
    <!-- 黑名单管理列表 -->
    <div class="main_container">
      <section class="model_section">
        <p class="model_top_title">黑名单管理</p>
      </section>
      <div class="table_container">
        <el-table :data="blacklist" stripe border>
          <el-table-column label="序号" width="60" align="center">
            <template scope="scope">{{scope.$index + 1}}</template>
          </el-table-column>
          <el-table-column label="商家名称" align="center">
            <template scope="scope">{{scope.row.businessname}}</template>
          </el-table-column>
          <el-table-column label="申请退款次数" align="center">
            <template scope="scope">{{scope.row.refundcount}}</template>
          </el-table-column>
          <el-table-column label="同意" align="center">
            <template scope="scope">{{scope.row.passcount}}</template>
          </el-table-column>
          <el-table-column label="拒绝" align="center">
            <template scope="scope">{{scope.row.nopasscount}}</template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="150" align="center">
            <template slot-scope="scope">
              <span class="handle" @click="yichu(scope.row)">
                <i class="el-icon-document-delete"></i> 移除</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination layout="prev, pager, next" @current-change="currentchangeTwo"
        :page-size="10" :total="totalTwo" :current-page="pageIndexTwo" style="margin:10px 0;float:right;"/>
      </div>
    </div>
  </div>
  
  <!-- 审核-弹框 -->
  <el-drawer title="审核" custom-class="registrationRecord" :visible.sync="isToExamine" size="30%">
    <ul style="line-height: 32px;">
      <li><span>退款原因：</span>{{ inform.resonid==4?'其它原因':inform.reson }}</li>
      <li v-show="inform.resonid==4"><span>退款备注：</span>{{ inform.reson }}</li>
      <li v-show="infoImgs.length>0">资料图片：</li>
      <span v-for="(item, index) in infoImgs" :key="index">
        <el-image :src="item" @click="handleClickItem" :preview-src-list="infoImgs"
        style="width: 80px; height: 80px;margin: 0 10px 10px 0;" fit="cover"/>
      </span>
      <!-- <li>通话录音：<span v-show="!recordurl">当前没有通话录音记录</span></li> -->
      <li>通话录音</li>
    </ul>
    <!-- <div style="text-align: center;">
      <audio :src="recordurl" controls="controls" style="margin-bottom: 20px;" v-show="recordurl"/>
    </div> -->
    <el-table :data="callrecords" border style="margin: 0px">
      <el-table-column label="序号" align="center" width="50">
        <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
      </el-table-column>
      <el-table-column label="通话时间" property="starttime" align="center"/>
      <el-table-column label="通话录音" align="center">
        <template scope="scope">
          <audio :src="api2cs + '/api/virtualnumber/callaudio/'+scope.row.tag+'/'+scope.row.callid+'/'+scope.row.orderid"
          v-show="scope.row.isexpires==0&&scope.row.tag" controls="controls" style="width: 90%;height: 35px;margin: 5px 0;"/>
          <span v-show="scope.row.isexpires==1">录音已过期</span>
          <span v-show="scope.row.tag==''||scope.row.tag==0">录音未生成</span>
        </template>
      </el-table-column>
    </el-table>
    <!-- 弹框按钮 确定/取消 -->
    <div style="text-align:center;margin-top: 20px;">
      <el-button type="danger" @click="toApproved(16)">驳回</el-button>
      <el-button type="primary" @click="toApproved(14)">通过</el-button>
    </div>
  </el-drawer>
  <!-- 预警值设置-弹框 -->
  <el-dialog title="预警值设置" :visible.sync="yjzsz" :center="true" width="20%">
    <el-form style="text-align: center;">
      <el-form-item label="退款拒绝次数：" style="width:80%;" label-width="80px">
        <el-input v-model="yjzinput" placeholder="请输入" style="width:80%" maxlength="5"
        onkeyup="this.value=this.value.replace(/\D|^0/g,'')">
        <i slot="suffix" style="margin-right: 10px;">次</i>
        </el-input>
      </el-form-item>
    </el-form>
    <!-- 弹框按钮 确定/取消 -->
    <div style="text-align:center">
      <el-button type="danger" @click="yjzsz = false">取消</el-button>
      <el-button type="primary" @click="qdyjz()">确定</el-button>
    </div>
  </el-dialog>
  
</section>
</template>
<script>
import { getauditlist, blacklistgetlist, getconfig, saveconfig, blacklistremove, orderchangestatus,
  callrecordlist, refundinfo } from "../../api/shopWindow";
export default {
  data() {
    return {
      show3: true,
      activeName: 'first', // tab切换标识
      orderid: "", // 订单id
      businessid: '', // 店铺ID

      orderNumber: "", // 店铺名称
      orderTime: "", // 申请时间
      beginTime: "", // 开始时间
      endTime: "", // 结束时间
      shztid: 0,
      shztArr: [
        {
          id: 0,
          name: "全部"
        },{
          id: 10,
          name: "待审核"
        },{
          id: 15,
          name: "审核通过"
        },{
          id: 16,
          name: "审核未通过"
        },
      ],
      chargebackList: [], // 审核管理
      pageIndexOne: 1, // 页码
      totalOne: 0, // 总条数

      qiyeName: '', // 店铺名称
      blacklist: [], // 黑名单管理
      pageIndexTwo: 1, // 页码
      totalTwo: 0, // 总条数
      
      isToExamine: false, // 审核弹框
      inform:{},
      infoImgs: [],
      recordurl: '', // 录音URL
      callrecords: [], // 录音列表
      api2cs: localStorage.api2cs,
      yjzsz: false,
      yjzinput: '100', // 退款拒绝次数
    };
  },
  methods: {
    // 切换tab
    handleClick(tab){
      if(tab.name=='first'){
        this.pageIndexOne = 1;
        this.getorder();
      }else{
        this.pageIndexTwo = 1;
        this.gethmd();
      }
    },
    // 查询
    onSubmit() {
      if(this.activeName=='first'){
        this.pageIndexOne = 1;
        this.getorder();
      }else{
        this.pageIndexTwo = 1;
        this.gethmd();
      }
    },
    // 获取审核管理列表
    getorder() {
      let obj = {
        keyword: this.orderNumber, // 店铺名称
        bdate: this.beginTime, // 开始时间
        edate: this.endTime, // 结束时间
        status: this.shztid, // 状态：0=全部 10=待审核 15=审核通过 16=审核未通过
        pageindex: this.pageIndexOne,
        pagesize: 10
      };
      getauditlist(obj).then(data => {
        if(data.resultCode == 1){
          this.chargebackList = data.resultObj.list;
          this.totalOne = data.resultObj.totalcount;
        }else{
          this.chargebackList = [];
          this.totalOne = 0;
        }
      })
    },
    // 分页
    currentchangeOne(val) {
      this.pageIndexOne = val;
      this.getorder();
    },
    // 获取黑名单管理列表
    gethmd() {
      let obj = {
        key: this.qiyeName, // 店铺名称
        pageindex: this.pageIndexTwo,
        pagesize: 10
      };
      blacklistgetlist(obj).then(data => {
        if(data.resultCode == 1){
          this.blacklist = data.resultObj.list;
          this.totalTwo = data.resultObj.totalcount;
        }else{
          this.blacklist = [];
          this.totalTwo = 0;
        }
      })
    },
    // 分页
    currentchangeTwo(val) {
      this.pageIndexTwo = val;
      this.gethmd();
    },
    // 审核
    shenhe(row) {
      this.orderid = row.orderid; // 赋值订单ID
      this.businessid = row.businessid; // 赋值店铺ID
      this.isToExamine = true;
      // let obj = {
      //   orderid: this.orderid, // 订单ID
      //   businessid: this.businessid, // 店铺ID
      //   pageindex: 1,
      //   pagesize: 1,
      // };
      // callrecordlist(obj).then(data => {
      //   if(data.resultCode == 1){
      //     this.recordurl = data.resultObj.list[0].recordurl;
      //   }
      // })
      refundinfo('',row.orderid).then(data=>{
        if(data.resultCode == 1){
          this.inform = data.resultObj.refundInfo;
          this.infoImgs = data.resultObj.imgs;
          // this.recordurl = data.resultObj.rings[0].recordurl;
          this.callrecords = data.resultObj.callrecords;
        }
      })
    },
    // 通过 & 驳回
    toApproved(type) {
      let approved = {
        businessid: this.businessid, // 店铺id
        orderid: this.orderid, // 订单id
        status: type, // 状态：10=申请退款 14=同意退款 16=不同意退款
        operatorid: localStorage.Id, // 当前操作人id
      };
      orderchangestatus(approved).then(data => {
        if(data.resultCode == 1){
          this.$swal({
            type: "success",
            text:"操作成功"
          });
          this.isToExamine = false;
          this.getorder();
        }else{
          this.$swal({
            type:'error',
            text: data.resultMsg,
          })
        }
      });
    },
    // 预警值设置
    handleyjz(){
      this.yjzsz = true;
      getconfig('').then(data => {
        if (data.resultCode == 1) {
          this.yjzinput = data.resultObj; // 黑名单配置值 （未配置时返回空）
        }
      });
    },
    // 确定
    qdyjz(){
      let obj = {
        operatorid: localStorage.Id, // 操作人id
        value: this.yjzinput, // 退款拒绝次数
      };
      saveconfig(obj).then(data => {
        if (data.resultCode == 1) {
          this.$swal({
            type: "success",
            text: '操作成功',
          });
          this.yjzsz = false;
          this.gethmd();
        }
      });
    },
    // 移除
    yichu(row){
      this.$swal({
        type: "warning",
        text: "重要信息，确定要从黑名单中移除这个店铺吗？",
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonText: "确定",
      }).then((res) => {
        if (res.value) {
          var obj = {
            cbid: row.cbid, // 黑名单主键
            // shopid: row.businessid, // 店铺ID
            businessid: row.businessid, // 业务ID
            cbtype: row.cbtype, // 黑名单类型 1=企业 2=商家 3=个人
          };
          blacklistremove(obj).then(data => {
            if (data.resultCode == 1) {
              if(data.resultObj>0){
                this.$swal({
                  type: "success",
                  text: '移除成功',
                });
                this.gethmd();
              }else{
                this.$swal({
                  type:'error',
                  text: data.resultMsg,
                })
              }
            }else{
              this.$swal({
                type:'error',
                text: data.resultMsg,
              })
            }
          });
        }
      });
    },
    // 申请时间
    changetime() {
      if(this.orderTime + "" == "null"){
        this.orderTime = ["",""]
      }
      this.beginTime = this.orderTime[0];
      this.endTime = this.orderTime[1];
    },
    // 关闭el-image遮罩层
    handleClickItem() {
      this.$nextTick(() => {
        // 获取遮罩层dom
        let domImageMask = document.querySelector('.el-image-viewer__mask')
        if (!domImageMask) {
          return
        }
        domImageMask.addEventListener('click', () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector('.el-image-viewer__close').click()
        })
      })
    },
  },
  mounted() {
    this.getorder();
  }
};
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// cancelOrder.vue?dc792008